module.exports = __webpack_public_path__ + "d6605c28c664b924fecabf54f7c25935.png";